@if (strategy()) {
  <div class="flex items-center justify-between" *transloco="let t" appNavBreadcrumb>
    <div class="type-body-medium text-muted-foreground flex items-center">
      <a iButton variant="ghost" routerLink=".." queryParamsHandling="preserve">{{ strategy()?.name }}</a>
      <span class="type-body text-subtle-foreground">/</span>
      <span class="text-foreground ml-1">{{ t("amc.strategy_analysis_new") }}</span>
    </div>
  </div>
}
<div class="absolute inset-0 block" *transloco="let t">
  @if (dspAdvertiserId() === null) {
    <div class="p-4">
      <IAlert type="warning">{{ t("amc.strategy_analysis_no_dsp_advertiser") }}</IAlert>
    </div>
  } @else {
    <app-form-shell>
      <div shellHeader>
        <IStepper [steps]="formSteps()" [form]="creationForm" (stepSelect)="goToStep($event)" clickable />
      </div>
      <div shellMain class="h-full min-h-0">
        @switch (currentStepId()) {
          @case ("strategy") {
            @if (dspStrategies(); as dspStrategies) {
              <app-amc-analysis-strategy-step [strategy]="creationForm.strategy" [strategies]="dspStrategies" />
            } @else {
              <div class="flex h-full items-center justify-center">
                <ISpinner />
              </div>
            }
          }
          @case ("template") {
            <app-amc-analysis-template-step [template]="creationForm.template" [options]="templateOptions()" />
          }
          @case ("period") {
            @if (selectedPeriodWindow(); as window) {
              <app-amc-analysis-period-step
                [period]="creationForm.period"
                [window]="window"
                [incompleteResultTemplates]="selectedIncompleteResultTemplates()"
              />
            }
          }
        }
      </div>
      <div shellFooter class="flex items-center justify-between gap-3">
        <button iButton variant="secondary" size="md" [disabled]="isCreating()" (click)="cancel()">
          {{ t("common.cancel") }}
        </button>

        <div class="flex gap-3">
          @if (!isFirstStep()) {
            <button iButton variant="secondary" size="md" [disabled]="isCreating()" (click)="back()">
              {{ t("common.back") }}
            </button>
          }
          <button iButton [disabled]="!canGoNext()" size="md" [loading]="isCreating()" (click)="next()">
            {{ isLastStep() ? t("amc.strategy_analysis_request") : t("common.next") }}
          </button>
        </div>
      </div>
    </app-form-shell>
  }
</div>
